import { NielsenLoadContentMetadataValue } from './types';
import * as Tracking from '../dataProviders/Tracking';

export type TimetableEntry = {
  start: number;
  stop: number;
  data: {
    kind: 'ad' | 'content';
    metadata: NielsenLoadContentMetadataValue;
    upcoming: TimetableEntry['data'] | undefined;
  };
};

/**
 * Maps nielsen nodes from EPG data to timetable array.
 * @internal
 * @param   nodes - Array of nielsen nodes.
 * @returns Timetable array.
 */
export function toTimetable(nodes: ReturnType<typeof Tracking.nielsen>) {
  return nodes.reduceRight<TimetableEntry[]>((accumulator, current) => {
    // Since the nodes are traversed in reverse order, the accumulator
    // contains the next nodes as opposed to the previous nodes.
    // This makes finding the upcoming program much simpler.
    const upcoming = accumulator.find((item: any) => !item.ad);
    if (current.ad && !upcoming) return accumulator;
    const item: TimetableEntry = {
      start: Math.floor(current.start / 1000),
      stop: Math.floor(current.stop / 1000),
      data: {
        kind: current.ad ? 'ad' : 'content',
        metadata: current.trackingObject ? JSON.parse(current.trackingObject) : null,
        upcoming: upcoming?.data,
      },
    };

    // Prepend the item to retain the original order
    return [item, ...accumulator];
  }, [] as TimetableEntry[]);
}
